import { validatorPermitirPetsComValorAdicional, validatorPermitirSomente3PetsSemValorAdicional, validatorPossui3Pets } from './funcoesAuxiliaresZPET';

export class CorrenteCadastroZPET {
    constructor(dependentes, parentesco, categorias, valoresForm, isValid) {
        this.dependentes = dependentes;
        this.parentesco = parentesco;
        this.categorias = categorias;
        this.arrayMsgsErro = [];
        this.valoresForm = valoresForm;
        this.isValid = isValid;
    }

    possui3pets() {
        if (validatorPossui3Pets(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Os próximos dependentes adicionados a esse plano terão um valor adicional de R$26,00');
        }

        return this;
    }

    permiteApenasDepentesTipoPet() {
        if (this.valoresForm.Parentesco.trim() !== 'PET') {
            this.arrayMsgsErro.push('Este plano permite apenas parentesco do tipo PET (ANIMAL)');
        }

        return this;
    }

    permitirSomente3PetsSemValorAdicional() {
        if (validatorPermitirSomente3PetsSemValorAdicional(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Este plano permite apenas 3 dependentes sem valor adicional');
        }

        return this;
    }

    permitirPetsComValorAdicional() {
        if (validatorPermitirPetsComValorAdicional(this.valoresForm, this.dependentes)) {
            this.arrayMsgsErro.push('Os 3 primeiros dependntes devem ser cadastrados sem valor adicional');
        }

        return this;
    }
}
